export default __webpack_public_path__ + "static/media/com.ebb277ad.svg";